
import { useNavigate } from 'react-router-dom';
import InstaLogo from '../../assets/images/insta.png'
import FacebookLogo from '../../assets/images/face book.png'
import TwitterLogo from '../../assets/images/twitter.png'
import LinkdinLogo from '../../assets/images/Group 239193 1.svg'
import AndroidLogo from '../../assets/images/ios_app_btn.png'
import YoutubeLogo from '../../assets/images/youtub.png'
import MailLogo from '../../assets/images/mail.png'
import PhoneLogo from '../../assets/images/call.png'
import selsmartLogo from '../../assets/images/selsmart_no.png'
import googlePlayStoreImage from '../../assets/images/Google_Play_Store_badge_EN 1.png'
import { useUser } from '../../contexts/userContext';

const Footer = () => {
    const navigate = useNavigate();
    const {setGlobalSearchTerm}  = useUser()

    const handleTermsOfConditions = () => {
        setGlobalSearchTerm("")
        window.open('/terms-and-conditions');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const handleFaqs = () => {
        setGlobalSearchTerm("");
        window.open('/faq');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const handleSellNow = () => {
        setGlobalSearchTerm("");
        navigate('/sell-used-appliances')
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const handleContactUS = () => {
        setGlobalSearchTerm("");
        navigate('/contact-us')
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const handleBulkPickup = () => {
        setGlobalSearchTerm("");
        navigate('/bulk-pickup')
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const handleCancellationPolicy = () => {
        setGlobalSearchTerm("");
        // navigate('/cancellation-policy')
        window.open('/cancellation-policy');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const handlePrivacy = () => {
        setGlobalSearchTerm("");
        window.open('/privacy-policy'); 
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const handleShipmentPolicy = () => {
        setGlobalSearchTerm("");
        window.open('/shipping-policy');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    const handleAboutUs = () => {
        setGlobalSearchTerm("");
        window.open('/about-us');
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const currentYear = new Date().getFullYear();

    const handleEmail = () => {
        window.location.href = 'mailto:care@selsmart.in';
      };

      const handlePhoneNumber = () => {
        window.location.href = 'tel:9355541464';
      };

    return (
        <footer className="footer">
            <div className="footer-top">
                <div className="column col_1">
                    <img src={selsmartLogo} alt="Selsmart Logo" />
                    <p>Sell used electronics the Smart way</p>
                </div>
                <div className="column col_2">
                    <h3>Company</h3>
                    <ul>
                        <li><a onClick={handleAboutUs} >About Us</a></li>
                        {/* <li><a href="/">Blogs</a></li> */}
                        {/* <li><a href="/">Sitemap</a></li> */}
                        {/* <li><a href="/">In the Media</a></li> */}
                        <li><a onClick={handleSellNow}>Sell Now</a></li>
                    </ul>
                </div>
                <div className="column col_3">
                    <h3>Policies</h3>
                    <ul>
                        <li><a onClick={handleCancellationPolicy}>Cancellation Policy</a></li>
                        <li><a onClick={handleShipmentPolicy}>Shipment Policy</a></li>
                        <li><a onClick={handlePrivacy}>Privacy &amp; Cookies</a></li>
                        <li><a onClick={handleTermsOfConditions}>Terms of Use</a></li>
                    </ul>
                </div>
                <div className="column col_4">
                    <h3>Help</h3>
                    <ul>
                        <li><a onClick={handleFaqs}>FAQ's</a></li>
                        <li><a onClick={handleContactUS}>Contact Us</a></li>
                        <li><a onClick={handleBulkPickup}>Bulk Pickup Request</a></li>
                    </ul>
                </div>
                <div className="column col_5">
    <div className='get_in_tuch_wrap'>
    <h3>Get in touch with us!</h3>
    <div className="social-icons">
        <a href='https://www.facebook.com/profile.php?id=61560032351288' target="_blank" rel="noopener noreferrer">
            <img src={FacebookLogo} alt="Facebook" />
        </a>
        {/* <a href='https://www.instagram.com/selsmart_/' target="_blank" rel="noopener noreferrer">
            <img src={InstaLogo} alt="Instagram" />
        </a> */}
        {/* <a href='https://twitter.com/AtteroIndia' target="_blank" rel="noopener noreferrer">
            <img src={TwitterLogo} alt="Twitter" />
        </a> */}
        <a href='https://www.linkedin.com/company/attero-recycling-pvt-ltd/' target="_blank" rel="noopener noreferrer">
            <img src={LinkdinLogo} alt="Linkdin" />
        </a>
        {/* <a href='https://youtube.com/@attero7549?si=LfIgln-DIE3I5TqX' target="_blank" rel="noopener noreferrer">
            <img src={YoutubeLogo} alt="Youtube" />
        </a> */}
    </div>
    </div>
    <div className="contact-info web">
      <p onClick={handlePhoneNumber}><img className="icon-footer" src={PhoneLogo} alt="Phone"/><a>+91-9355541464</a></p>
      <p onClick={handleEmail}> <img className="icon-footer" src={MailLogo} alt="Email" /><a >care@selsmart.in</a></p>
  </div>
</div>
<div className='column col_6'>
<h3>Contact Us</h3>
<div className="contact-info mob">
      <p onClick={handlePhoneNumber}><img className="icon-footer" src={PhoneLogo} alt="Phone"/><a >+91-9355541464</a></p>
      <p onClick={handleEmail}> <img className="icon-footer" src={MailLogo} alt="Email" /><a >care@selsmart.in</a></p>
  </div>
</div>
            </div>
            <div className="footer-bottom d-none">
  <div className="contact-info">
      <p onClick={handlePhoneNumber}><img className="icon-footer" src={PhoneLogo} alt="Phone"/>+91-9355541464</p>
      <p onClick={handleEmail}><img className="icon-footer" src={MailLogo} alt="Email" />care@selsmart.in</p>
  </div>
  <div className="column">
      <h3>Download Selsmart App</h3>
      <div className="app-download">
          <a className="Play-store" href="#"><img src={googlePlayStoreImage} alt="Google Play"/></a>
          <a className="ios_store" href="#"><img src={AndroidLogo} alt="App Store"/></a>
      </div>
  </div>
</div>
<div className="footer_copy_right text-center align-items-center">
<div className="social-icons mview">
        <a href='https://www.facebook.com/profile.php?id=61560032351288' target="_blank" rel="noopener noreferrer">
            <img src={FacebookLogo} alt="Facebook" />
        </a>
        {/* <a href='https://www.instagram.com/selsmart_/' target="_blank" rel="noopener noreferrer">
            <img src={InstaLogo} alt="Instagram" />
        </a> */}
        <a href='https://www.linkedin.com/company/attero-recycling-pvt-ltd/' target="_blank" rel="noopener noreferrer">
            <img src={LinkdinLogo} alt="Linkdin" />
        </a>
        {/* <a href="https://youtube.com/@attero7549?si=LfIgln-DIE3I5TqX" target="_blank" rel="noopener noreferrer">
            <img src={YoutubeLogo} alt="Youtube" />
        </a> */}
    </div>
    © {currentYear} Selsmart All rights reserved.</div>
        </footer>
    )
}
export default Footer;

